// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1b8faf74","455":"d7e115d4","977":"543fa958"}[chunkId] + ".chunk.js";
};